import { useSubscription } from '@/hooks/useSubscription';

export function hasFeature(feature: string): boolean {
  const { subscription } = useSubscription();
  const features = subscription?.subscription?.features || [];

  return features.some(f =>
    typeof f === 'string' &&
    f.toLowerCase().includes(feature.toLowerCase())
  );
}
